export default __webpack_public_path__ + "static/media/E4.309d6d90.mp3";